import React from 'react';
import callApi from './../../utils/apicaler';
import Outsoure from ".././pageChild/Outsoure";
import Footer from ".././pageChild/Footer";
import Intagram from ".././pageChild/Intagram";
import NavBar from ".././pageChild/NavBar";
import AddCart from ".././pageChild/AddCart";
import End from ".././pageChild/End";
import Simple from ".././pageChild/Simple";
import CartPage from "../.././page/pageCart/CartPage";
import Addtion from "./viewChild/Addtion";
import RandomCart from "./viewChild/RandomCart";
import  { Redirect } from 'react-router-dom';
import ArrowDropUpIcon from '@material-ui/icons/ArrowDropUp';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import {
  Link
} from "react-router-dom";


var carts = [];
class ViewProduct extends React.Component{
    constructor(props){
            super(props);
 
            this.state = {
                products : [],
                setImageMain:"",
                loader:"",
                cartId:0,
                qty:[],
                addQ:1,
                errQty:"",
                showCart:"",
                fixedQty:"",
                op:"",
                redirct:0,
                status:0,
                errAdd:"",
                productsPai:[],
                setImageName:"",
                color:"",
                size:"",
                errQtyColor:"",
                errQtySize:"",
                loai:""
               
            }
        }



    componentDidMount(){
            var {match} = this.props;
            var {qty} = this.state;
            setInterval(() => {
                this.setState({ redirct:200 });
            }, 500);
            callApi('views', 'GET', null).then(res =>{
                    if(res.status == 200){
                    this.setState({ productsPai : res.data });

                }
            })


            if(match){
                var id = match.params.id;
                callApi(`5f1db6e5a8ee4200b0bff195/${id}`, 'GET', null).then(res =>{
                    this.setState({
                        status :res.status,
                        products : res.data,
                        setImageMain : res.data.imgeFile,
                        setImageName : res.data.products
                    })
                    sessionStorage.setItem("title", res.data.products);
                })
            }
            
            
            var cart = JSON.parse(sessionStorage.getItem('products'));
            if(cart === null){
                console.log("!")
            }else{
                cart.map((carts, index)=>{
                    this.setState({cartId: index + 1})
                })
            }
    }

    incre = () =>{
        var {addQ} = this.state;

        this.setState({addQ:addQ += 1})

    }

    uncre = () =>{
        var {addQ} = this.state;
        if( addQ < 2){

        }else{
            this.setState({addQ:addQ -= 1})
            }         
    }

    addCart = () =>{
        let {products, addQ, qty,setImageMain,color, size, loai} = this.state;
          
        // console.log(products.sale)
        if(products.sale === "SALE"){
            let qtyes_ = [
                {
                    _id:products._id,
                    products:products.products,
                    qty:addQ,
                    price:((parseInt(products.price)*(1 - parseInt(products.salePrice)/100.0))),
                    salePrice:products.salePrice,
                    sale:products.sale,
                    conten:products.conten,
                    date:products.date,
                    species:products.species,
                    setImageMain:setImageMain,
                    color:color,
                    size:size,
                    loai:loai
                }
            ]
            if( qtyes_[0] === undefined ){
                this.setState({errQty:"errQty"})
                return true
            }else if( qtyes_[0].qty === 0 ){
                this.setState({errQty:"errQty"})
                return true
            }else if( color === "" ){
                this.setState({errQtyColor:"errQty"})
                return true
            }else if( products.conten === "Thời trang" ){
                if(size === ""){
                    this.setState({errQtySize:"errQty"})
                    return true
                }
            }else{
                this.setState({errQty:"",errQtyColor:"",errQtySize:""})
            }
            {this.addQty(qtyes_, products, setImageMain)}
        }else{
            let qtyes_ = [
                {
                    _id:products._id,
                    products:products.products,
                    qty:addQ,
                    price:products.price,
                    conten:products.conten,
                    date:products.date,
                    species:products.species,
                    setImageMain:setImageMain,
                    color:color,
                    size:size,
                    loai:loai
                }
            ]
            if( qtyes_[0] === undefined ){
                this.setState({errQty:"errQty"})
                return true
            }else if( qtyes_[0].qty === 0 ){
                this.setState({errQty:"errQty"})
                return true
            }else if( color === "" ){
                this.setState({errQtyColor:"errQty"})
                return true
            }else if( products.conten === "Thời trang" ){
                if(size === ""){
                    this.setState({errQtySize:"errQty"})
                    return true
                }
            }else{
                this.setState({errQty:"",errQtyColor:"",errQtySize:""})
            }
            {this.addQty(qtyes_, products, setImageMain)}
        }

        
        
        
        sessionStorage.setItem("products", JSON.stringify(carts));

        carts.map((cart, index)=>{
            this.setState({cartId: index+1})
        })
  

    }

    addQty = (qtyes_,products, setImageMain) =>{


    qtyes_.map((qtys, index)=>{
        var cart = JSON.parse(sessionStorage.getItem('products'));


        if(cart === null){
            console.log("null")
            carts.push(qtys) 
            this.setState({showCart: "showCart", fixedQty: "fixedQty", op:"op"})
        }else{
            var index = -1;
            index = this.findProduct(cart, qtys)
            if(index !== -1){
                this.setState({ errAdd: "Sản phẩm này đã được thêm vào giỏ" });
            }else{
                carts.push(qtys) 
                this.setState({showCart: "showCart", fixedQty: "fixedQty", op:"op"})
            }
            
        }

    })
}

    offCart=()=>{
        this.setState({showCart: "", fixedQty: "", op:""})
    }
   



    findProduct=(cart, productsCart)=>{
        var index = -1;
        if(cart.length > 0){
            for (var i =0; i < cart.length; i++){
                if(cart[i]._id === productsCart._id){
                    index = i;
                    break;
                }
            }
        }
        return index;
    }


   delete = (id) =>{
        const index = this.findIndex(id);
        sessionStorage.setItem("products", JSON.stringify(carts));
    }

    findIndex(id){
        carts.map((cart, index)=>{
            this.setState({cartId: index+1})
            if(cart._id === id){
                return carts.splice(index, 1);
            }
        })
        return -1;
    }

    totalCart=(carts)=>{
        var total = 0;
        if(carts.length > 0){
            for (const i in carts){ 
                total += carts[i].price * carts[i].qty
            }
        }
        return total;
    }

    setImage1=(p, c)=>{
        this.setState({setImageMain: p, color:c})
    }

    setSize=(s)=>{
        this.setState({size:s})
    }
    setLoai=(l)=>{
        this.setState({loai:l})
    }

    // showCompleImg = (datas, setImageName, setImageMain)=>{
    //     var result = null;
    //     result = datas.map((products, index)=>{
    //         return ( 
    //              products.products === setImageName ?
    //                 <div className="col-xs-3 col-sm-3 col-md-3 col-lg-3 custom_col" key={index}>
    //                     {products.imgeFile1 === "" ? 
    //                         <div className="notImg"></div> :
    //                         <div>
    //                         <div className="img_views" onClick={()=> this.setImage1(products.imgeFile1, products.color)}>
    //                             <img src={this.state.status === 200 ? `https://planet-time-linseed.glitch.me/${products.imgeFile1}` : "https://cdn.glitch.com/1a2d3926-a597-412c-a998-a0aa2ca0b31a%2FInsistentTautGodwit-small.gif?v=1593966696199"} id={setImageMain === products.imgeFile1 ? "active" : ""}/>
                             
    //                         </div>
    //                         <div className="button_size" onClick={()=> this.setImage1(products.imgeFile1, products.color)} id={ products.products === setImageName ? "" : "display_not"}>
    //                             <Link><button style={{background:products.color, borderRadius:"20px", width:"20px", height:"20px"}} id={this.state.color === products.color ? "active" : "not-ac"}></button></Link>
    //                         </div>
    //                         <div className="button_size" id={ products.products === setImageName ? "" : "display_not"}>
    //                             <button id={products.size === "" ? "display_not" : ""} onClick={()=> this.setSize(products.size)} className={this.state.size === products.size ? "color_active" : "not-ac"}>{products.size}</button>
    //                         </div>
    //                         <div className="button_size" id={ products.products === setImageName ? "" : "display_not"}>
    //                             <button style={{width:"48px"}} id={products.loai === "" ? "display_not" : ""} onClick={()=> this.setLoai(products.loai)} className={this.state.loai === products.loai ? "color_active" : "not-ac"}>{products.loai}</button>
    //                         </div>

    //                         </div>

    //                     }
    //                 </div>

    //              : 
    //              ""
                
    //         )
    //     })
    //     return result;
    // }

        showCompleImg = (datas, setImageName, setImageMain)=>{
        var result = null;
        result = datas.map((products, index)=>{
            return ( 
                 products.products === setImageName ?
                    <div className="col-xs-4 col-sm-4 col-md-4 col-lg-4 custom_col" key={index}>
                        {products.imgeFile1 === "" ? 
                            <div className="notImg"></div> :
                                <div>
                                    <div class="box">
                                        <div className="img_views" onClick={()=> this.setImage1(products.imgeFile1, products.color)}>
                                           <img src={this.state.status === 200 ? products.imgeFile1 : "https://cdn.glitch.com/1a2d3926-a597-412c-a998-a0aa2ca0b31a%2FInsistentTautGodwit-small.gif?v=1593966696199"} id={setImageMain === products.imgeFile1 ? "active" : ""}/>
                                        </div>
                                        <div className="button_size" onClick={()=> this.setImage1(products.imgeFile1, products.color)} id={ products.products === setImageName ? "" : "display_not"}>
                                            <Link><button style={{background:products.color, borderRadius:"20px", width:"20px", height:"20px"}} id={this.state.color === products.color ? "active" : "not-ac"}></button></Link>
                                        </div>
                                        <div className="button_size" id={ products.products === setImageName ? "" : "display_not"}>
                                            <button id={products.size === "" ? "display_not" : ""} onClick={()=> this.setSize(products.size)} className={this.state.size === products.size ? "color_active" : "not-ac"}>{products.size}</button>
                                        </div>
                                        <div className="button_size" id={ products.products === setImageName ? "" : "display_not"}>
                                            <button style={{width:"48px"}} id={products.loai === "" ? "display_not" : ""} onClick={()=> this.setLoai(products.loai)} className={this.state.loai === products.loai ? "color_active" : "not-ac"}>{products.loai}</button>
                                        </div>

                                    </div>
                  
                                </div>
                                    
                            }
                        </div>

                     : 
                     ""
                    
                )
            })
            return result;
        }


    onChangeColor=(color)=>{
        console.log(color)
        this.setState({color:color})
    }


    showComple = (datas)=>{

        var result = null;
        result = datas.map((cart, index)=>{
            return ( 
                <tbody>
                    <tr key={index}>
                        <td style={{position:"relative"}}>
                            <CloseIcon onClick={()=> this.delete(cart._id)}/>
                            
                            {cart.sale === "SALE" ? <span style={{color:"#fff", position: "absolute", top: "26px",left:"10px",background: "red" }}>{cart.salePrice}</span> : <span style={{position: "absolute", top: "26px",left:"10px",background: "#3cd3dd", color:"#fff" }}>New</span>}
                            <img src={cart.setImageMain} />
                        </td>
                        <td>x{cart.qty}</td>
                        <td style={{textTransform: "uppercase"}}>{cart.products}
                            <br/>
                            <span>Màu: <span style={{background:cart.color, padding:"0px 7px", borderRadius:"7px"}}></span></span> &nbsp;
                            <span id={cart.size === "" ? "display_not" : ""}>Size: {cart.size}</span>
                            <span id={cart.loai === "" ? "display_not" : ""}>Loại: {cart.loai}</span>
                        </td>
                        <td></td>
                    </tr>
                </tbody>

            )
        })
        return result;
    }
    text2html = (data) => {
        return (
            <div className="content" dangerouslySetInnerHTML={{__html: data}}></div>
        )
    }


    render(){
        var {status ,setImageName,errQtySize, productsPai, boderColor, setImageMain, loader,errQtyColor, products,color, cartId, addQ, showCart, errQty, fixedQty, op, redirct, errAdd} = this.state;
        var title = sessionStorage.getItem('title');
        var wapper = <div className={`container-fluid custom_fluid`}>
                        <title>{title}</title>
                        <div className="row custom_row">
                            <div className={`col-xs-12 col-sm-12 col-md-12 col-lg-12 custom_col ${fixedQty}`}>
                                <div className="row custom_row" >
                                    <div className="col-xs-6 col-sm-6 col-md-6 col-lg-6">
                                        
                                    </div>
                                    <div className="col-xs-6 col-sm-6 col-md-6 col-lg-6">
                                        <div className={`nav_cart navbar-fixed-top ${showCart}`} style={{overflowY: "auto"}}>
                                            <div className="cart_comple">
                                                <div className="close_qty">
                                                    <CloseIcon onClick={this.offCart}/>
                                                </div>
                                                <h3>Your basket</h3>
                                                <table>
                                                  <thead>
                                                    <tr>
                                                      <th></th>
                                                      <th></th>
                                                      <th></th>
                                                      <th></th>
                                                    </tr>
                                                  </thead>
                                                    <tbody>
                                                        {this.showComple(carts)}
                                                    </tbody>

                                                </table>
                                                <hr/>
                                                <table>
                                                    <tr>
                                                        <th>Tổng</th>
                                                        <th>{this.totalCart(carts)}.000 VND</th>
                                                    </tr>
                                                </table>
                                                <div className="send_mails">
                                                    <Link to="/cart" ><button type="button" className="qty_button">ĐI ĐẾN GIỎ</button></Link>
                                                    <button className="qty_button" type="button" onClick={this.props.history.goBack} style={{background:"#3cd3dd",border: "1px solid #3cd3dd"}}>TIẾP TỤC MUA HÀNG</button>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <NavBar cartId={cartId} />
                                <div className="row custom_row">
                                    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                        <div className="link_nav">
                                            <Breadcrumbs aria-label="breadcrumb">
                                              <Link color="inherit" to='/'>
                                                Trang chủ
                                              </Link>
                                              <Link color="inherit" to={`/${products.conten}`}>
                                                {products.conten}
                                              </Link>w6im11
                                              <Typography color="textPrimary">Mô tả sản phẩm</Typography>
                                            </Breadcrumbs>
                                        </div>
                                    </div>  
                                </div>
                                <div className={`row custom_row ${op}`}>
                                    <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                                        <div className="view-wapper">
                                            {status === 200 ? 
                                                <div className="img_view">
                                                    <img src={setImageMain} />
                                                </div>:
                                                <div className="img_view">
                                                    <img src="https://cdn.glitch.com/1a2d3926-a597-412c-a998-a0aa2ca0b31a%2FInsistentTautGodwit-small.gif?v=1593966696199" />
                                                </div>
                                            }
                                            <div className="row custom_row" style={{display: "flex", position:"relative", overflowX:"scroll"}}>
                                                <div class="slider">
                                                    <div class="containerol">
                                               {this.showCompleImg(productsPai, setImageName, setImageMain)} 
                                            </div>
                                            </div>
                                            </div>
                                        </div>
                                    </div>
                                        <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                                            <div className="conten_view">
                                                <b>NEW PRINTS</b>
                                                <h3>{products.products}</h3>
                                                <hr/>
                                                <span style={{textDecoration: products.sale === "SALE" || products.sale === "HET HANG" ? "line-through" : ""}}>{`${products.price}.000 VND`}</span>
                                                <br/>
                                                {products.sale === "SALE" || products.sale === "HET HANG" ? 
                                                    <b style={{fontSize:"25px", color:"red"}}>{((parseInt(products.price)*(1 - parseInt(products.salePrice)/100.0)))}.000VND</b>
                                                 : ""}
                                           
                                                <br/>
                                                <div className="qty_see">
                                                    <input type="text" onChange={this.onChangeQty} name="quantity" value={addQ} className="input_text"/>
                                                    <span className="qty_sp1">
                                                        <ArrowDropUpIcon onClick={this.incre} style={{fontSize:"30px"}}
                                                        />
                                                    </span>
                                                    <span className="qty_sp2" style={{display:"block"}}>
                                                        <ArrowDropDownIcon onClick={this.uncre} style={{fontSize:"30px"}}
                                                        />
                                                    </span>
                                                </div>
                                                {errQty === "" ? "" : <p className={`${errQty}`}>Xin mời thêm số lượng</p>}
                                                {errQtyColor === "" ? "" : <p className={`${errQtyColor}`}>Xin mời thêm mã màu </p>}
                                                {errQtySize === "" ? "" : <p className={`${errQtySize}`}>Xin mời thêm size </p>}
                                                <p className="errAdd">{errAdd}</p>                                        <br/>
                                                {products.sale === "HET HANG" ? 
                                                
                                                <button style={{background:"#821c1c", border:"1px solid #821c1c"}} className="button"
                                                    type="button"
                                                >HẾT HÀNG
                                                </button>
                                                :
                                                <button className="button"
                                                    type="button"
                                                    onClick={this.addCart}
                                                >ADD TO CART
                                                </button>
                                                }
                                                {this.text2html(products.describe)}
                                                <hr/>
                                                <h4>DATE : <b>{products.date}</b></h4>
                                                <h4>CATEGORY: <b> NEW PRINTS </b></h4>
                                                <h4>TAG : <b>{products.species}</b></h4>
                                            </div>
                                        </div>
                                </div>
                                <Addtion products={products}/>

                               
                                 <div className="row custom_row">
                                     <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 custom_col">
                                        <div className="out_soure">
                                            <div className="img_out" style={{height:"615px",padding:"0px"}}>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <RandomCart />
                                <hr/>
                                <Intagram />
                                <Footer />
                                <End />
                            </div>
                        </div>
                    </div>
            return ( 
               <div>
                { redirct === 200 ? wapper : <div className="loader loader-black loader-1"></div>}
            </div>
            )
        }
    }
export default ViewProduct;